import { autocompletion } from "@codemirror/autocomplete"

// FIXME: URI is no longer reliable to get box and or zettel slug
// Instead store the box slug on the local page as a global stimulus variable
// and use it to fetch the zettels
export function zettelLinker({ boxSlug }) {
  let zettelCache = null

  async function fetchZettels(query = "") {
    if (!boxSlug) {
      throw new Error("boxSlug is not defined")
    }

    if (!query && zettelCache) {
      return zettelCache
    }

    const baseEndpoint = `/api/box/${encodeURIComponent(boxSlug)}/zettels`
    const endpoint = query
      ? `${baseEndpoint}/search?q=${encodeURIComponent(query)}`
      : baseEndpoint

    const response = await fetch(endpoint, {
      headers: {
        'Accept': 'application/json'
      }
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch zettels: ${response.statusText}`)
    }

    const data = await response.json()

    if (!query) {
      zettelCache = data
    }

    return data
  }

  async function zettelCompletions(context) {
    const bracketMatch = context.matchBefore(/\[\[([^\]]*)$/)
    if (!bracketMatch) return null

    const query = bracketMatch.text.substring(2)

    try {
      const zettels = await fetchZettels(query)
      return {
        from: bracketMatch.from + 2,
        options: zettels.map(zettel => ({
          label: zettel.title,
          apply: `${zettel.title}|${zettel.slug}]]`,
          zettel: zettel
        })),
        validFor: /^[^\]]*$/
      }
    } catch (error) {
      console.error("Error fetching zettels:", error)
      return null
    }
  }

  return autocompletion({
    override: [zettelCompletions]
  })
}
